module.exports = __webpack_public_path__ + "img/psychiatrist.adaa5f55.svg";